import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../modules/filtering';
import { KCAL } from '../modules/constants';
import { Flags } from './flags';
import { Lozenge } from './lozenge';

function combineBastes(modifierOptionBastes, topLevelBastes) {
    return modifierOptionBastes
        .filter((item) =>
            isEmpty(
                topLevelBastes.find((baste) => baste.slug === item.slug)
                    .restaurantGroup
            )
        )
        .map((item) => {
            const topLevelBaste = topLevelBastes.find(
                (baste) => baste.slug === item.slug
            );
            const { colour, nutritionalInfo, flags } = topLevelBaste;
            // Only use modifier option lozenge, do not fall back to top-level lozenge
            const lozenge = item.lozenge;
            return {
                slug: item.slug,
                colour: colour ? colour : '#000',
                displayName: item.displayName,
                description: topLevelBaste.description,
                energyKcal: nutritionalInfo ? nutritionalInfo.energyKcal : 0,
                flags,
                lozenge
            };
        });
}

/**
 * Currently unused bases information. Will display formatted messages about available bastes using keys from the API.
 *
 * @function
 * @param       {array} bastes list of bastes returned from the API for the menu item.
 * @constructor
 */
function Bastes({ baste, bastes, hideCalories, nandinos, toggle, title }) {
    if (!bastes || !baste) {
        return null;
    }

    const ourBastes = combineBastes(baste, bastes);

    if (nandinos) {
        ourBastes.reverse();
    }

    return (
        <>
            <h4 onClick={toggle} className='opener'>
                {title}
            </h4>
            <div className='panel'>
                {ourBastes.map(
                    (
                        { displayName, description, energyKcal, colour, flags, lozenge },
                        idx
                    ) => {
                        return (
                            <React.Fragment key={`b-${idx}`}>
                                <div className='pdpspices'>
                                    <h5 style={{ color: colour.hexCode }}>
                                        <span>{displayName}</span>
                                        {lozenge ? (
                                            <Lozenge lozenge={lozenge} isForBaste={true} />
                                        ) : (
                                            <Flags flags={flags} isForBaste={true} />
                                        )}
                                    </h5>
                                    <p> {description}</p>
                                    {hideCalories ? null : (
                                        <p>
                                            {energyKcal} {KCAL}
                                        </p>
                                    )}
                                </div>
                            </React.Fragment>
                        );
                    }
                )}
            </div>
        </>
    );
}

Bastes.propTypes = {
    baste: PropTypes.array,
    bastes: PropTypes.array,
    hideCalories: PropTypes.bool,
    nandinos: PropTypes.bool,
    title: PropTypes.string,
    toggle: PropTypes.func
};

export { Bastes };
